var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddButtons({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f003c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "view_agenda_FILL0_wght400_GRAD0_opsz48",
    className: "cls-1",
    d: "M8.083,17.458A2.136,2.136,0,0,1,6,15.375V8.083A2.136,2.136,0,0,1,8.083,6H28.917A2.136,2.136,0,0,1,31,8.083v7.292a2.136,2.136,0,0,1-2.083,2.083Zm0-2.083H28.917V8.083H8.083ZM8.083,31A2.136,2.136,0,0,1,6,28.917V21.625a2.136,2.136,0,0,1,2.083-2.083H28.917A2.136,2.136,0,0,1,31,21.625v7.292A2.136,2.136,0,0,1,28.917,31Zm0-2.083H28.917V21.625H8.083Zm0-20.833v0Zm0,13.542v0Z",
    transform: "translate(-6 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButtons);
export default __webpack_public_path__ + "static/media/add-buttons.b06ba97cdc4eda59df46dbcb069040e5.svg";
export { ForwardRef as ReactComponent };